module.exports = __webpack_public_path__ + "img/25_6.5fbac16c.png";